import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';

const ActiveStep = (props) => {
  const {
    component, id, onComplete, onNextStep,
  } = props;
  const Component = component;
  return (
    <div className="active-step">
      <div className="content-wrapper">
        <Component
          {...props}
          onComplete={() => onComplete(id, true)}
          onNextStep={() => onNextStep(id)}
        />
      </div>
    </div>
  );
};

ActiveStep.defaultProps = {
  component: noop,
  id: '',
  completed: false,
  onComplete: noop,
  onNextStep: noop,
};

ActiveStep.propTypes = {
  component: PropTypes.func,
  id: PropTypes.string,
  completed: PropTypes.bool,
  onComplete: PropTypes.func,
  onNextStep: PropTypes.func,
};

ActiveStep.displayName = 'ActiveStep';

export default ActiveStep;



// WEBPACK FOOTER //
// ./src/components/steps/ActiveStep.js